// extracted by mini-css-extract-plugin
export default {"skeletonLoader":"SkeletonLoader_skeletonLoader__SQ30y","skeletonCard":"SkeletonLoader_skeletonCard__k9OoT"};